export const isTrue = (value) => {
  return value !== null && parseInt(value) === 1
}

export const isFalse = (value) => {
  return !isTrue(value);
}
